import { createSlice } from '@reduxjs/toolkit'
import {
  createPageAction,
  deletePageAction,
  listPageAction,
  updatePageAction,
  detailPageAction,
  settingShowPageAction,
} from './page.action'

const initialState: Page.PageState = {
  isLoading: false,
  error: null,
  pages: {
    limit: 0,
    page: 0,
    records: [],
    total: 0,
    totalPage: 0,
  },
  page: null
}

const { actions, reducer } = createSlice({
  name: 'page',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listPageAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(listPageAction.fulfilled, (state, action) => {
        state.isLoading = false
        state.pages = action.payload
      })
      .addCase(listPageAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(detailPageAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(detailPageAction.fulfilled, (state, action) => {
        state.page = action.payload
        state.isLoading = false;
      })
      .addCase(detailPageAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })

      .addCase(createPageAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(createPageAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(createPageAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(updatePageAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(updatePageAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updatePageAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(deletePageAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deletePageAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deletePageAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })

      .addCase(settingShowPageAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(settingShowPageAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(settingShowPageAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
  },
})

export { reducer }
export default actions
